import React from "react";
import PropTypes from "prop-types";
import { ASSETS } from "../../../../utils/config";
import { EmptyWheelsContainer } from "../styles";
import TextView from "../../../TextView";

// Define tab categories as constants
const WHEEL_CATEGORIES = {
  Created: 'Created',
  Cloned: 'Cloned',
  Unlocked: 'Unlocked',
  Favourited: 'Favourited'
};

const tabIcons = {
  [WHEEL_CATEGORIES.Created]: ASSETS.CreatedTabEmptyState,
  [WHEEL_CATEGORIES.Cloned]: ASSETS.ClonedTabEmptyState,
  [WHEEL_CATEGORIES.Unlocked]: ASSETS.UnlockedTabEmptyState,
  [WHEEL_CATEGORIES.Favourited]: ASSETS.FavouritedTabEmptyState,
};

const EmptyListView = ({ selectedTab }) => {
  return (
    <EmptyWheelsContainer>
      <img
        src={tabIcons[selectedTab] || ASSETS.CreatedTabEmptyState}
        width={100}
        height={100}
        alt={`No wheels in ${selectedTab} category!`}
      />
      <TextView style={{ color: "rgba(0, 0, 0, 0.80)" }} variant="Header3">
        No wheels in {selectedTab === WHEEL_CATEGORIES.Favourited ? "Favorited" : selectedTab} category!
      </TextView>
    </EmptyWheelsContainer>
  );
};

EmptyListView.propTypes = {
  selectedTab: PropTypes.oneOf([
    WHEEL_CATEGORIES.Created, 
    WHEEL_CATEGORIES.Cloned, 
    WHEEL_CATEGORIES.Unlocked, 
    WHEEL_CATEGORIES.Favourited
  ]).isRequired,
};

export default EmptyListView;
